import * as styles from "./BreadcrumbItem.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { BreadcrumbItemProps } from "./Breadcrumb.types";

export function BreadcrumbItem({
  children,
  className,
}: BreadcrumbItemProps): JSX.Element {
  return (
    <li data-slot="breadcrumb-item" className={clsx(styles.item, className)}>
      {children}
    </li>
  );
}
